import { PAYMENT_MULTI_STEPS } from '../../utils/steps';
import { StepPerformanceWrapper } from '../atoms/step-performance-wrapper';
import { CareCreditEnrollNavigationSwitch } from './care-credit-enroll/care-credit-enroll-navigation-switch';

export const CareCreditEnroll = () => {
  return (
    <StepPerformanceWrapper step={PAYMENT_MULTI_STEPS.careCreditEnroll}>
      <CareCreditEnrollNavigationSwitch />
    </StepPerformanceWrapper>
  );
};
